// @flow
import messages from '../components/EditHouseholdForm/messages';

/**
 * Validates duplicate phone numbers within an adult's contact information array
 */
export const validatePhoneDuplicates = (
  phones: Array<{ phoneNumber?: string }>,
  intl?: Object,
): Array<{ phoneNumber?: string }> => {
  const phonesErrors = [];
  const phoneValues = [];

  phones.forEach((phone, index) => {
    const phoneErrors = {};

    // Track phone values for duplicate checking
    if (phone.phoneNumber && phone.phoneNumber.trim()) {
      phoneValues.push(phone.phoneNumber.trim());
    }

    phonesErrors[index] = phoneErrors;
  });

  // Check for duplicate phone numbers
  const uniquePhones = new Set(phoneValues);
  if (phoneValues.length !== uniquePhones.size) {
    // Find which phones are duplicates and mark them
    const seenPhones = new Set();
    phones.forEach((phone, index) => {
      if (phone.phoneNumber && phone.phoneNumber.trim()) {
        const trimmedPhone = phone.phoneNumber.trim();
        if (seenPhones.has(trimmedPhone)) {
          // This is a duplicate
          if (!phonesErrors[index]) phonesErrors[index] = {};
          phonesErrors[index].phoneNumber = intl
            ? intl.formatMessage(messages.phoneNumbersMustBeDifferent)
            : 'Phone numbers must be different';
        } else {
          seenPhones.add(trimmedPhone);
        }
      }
    });
  }

  return phonesErrors;
};

/**
 * Validates duplicate email addresses within an adult's contact information array
 */
export const validateEmailDuplicates = (
  emails: Array<{ emailAddress?: string }>,
  intl?: Object,
): Array<{ emailAddress?: string }> => {
  const emailsErrors = [];
  const emailValues = [];

  emails.forEach((email, index) => {
    const emailErrors = {};

    // Track email values for duplicate checking
    if (email.emailAddress && email.emailAddress.trim()) {
      emailValues.push(email.emailAddress.trim());
    }

    emailsErrors[index] = emailErrors;
  });

  // Check for duplicate email addresses
  const uniqueEmails = new Set(emailValues);
  if (emailValues.length !== uniqueEmails.size) {
    // Find which emails are duplicates and mark them
    const seenEmails = new Set();
    emails.forEach((email, index) => {
      if (email.emailAddress && email.emailAddress.trim()) {
        const trimmedEmail = email.emailAddress.trim();
        if (seenEmails.has(trimmedEmail)) {
          // This is a duplicate
          if (!emailsErrors[index]) emailsErrors[index] = {};
          emailsErrors[index].emailAddress = intl
            ? intl.formatMessage(messages.emailAddressesMustBeDifferent)
            : 'Email addresses must be different';
        } else {
          seenEmails.add(trimmedEmail);
        }
      }
    });
  }

  return emailsErrors;
};
